import * as React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
// import AuthRoute from '@/display/components/AuthRoute';
import Login from '@/display/modules/Login';
import Register from '@/display/modules/Register';
import Home from '@/display/modules/Home';
import CommonUtils from '@/utils/commonUtils';
import { connect } from 'react-redux';
//需要渲染什么数据
function mapStateToProps(state) {
  return {
    userInfo: state
  }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
  return {
    PayIncrease: (v) => dispatch({ type: 'change', value: v }),
  }
}
class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tableScroll: null
    };
  }

  UNSAFE_componentWillMount() {
    // console.log('this.props', this.props);
    this.calcHtmlFontSize();

    // 跳转屏幕分辨率时，重新设置html字体
    const self = this;
    window.onresize = function () {
      self.calcHtmlFontSize();
    };
  }

  calcHtmlFontSize = () => {
    let ratio = CommonUtils.getZoomRatio();

    // bi大屏
    if (window.location.href.indexOf('/bi') > 0) {
      // console.log('bi');
      ratio = 1;
    }
    // const clientHeight = document.documentElement.clientHeight;
    // const ratio = clientHeight / Config.fitHeight;

    // 控制最大比例，避免分辨率过大，字体等显示过于巨大问题
    if (ratio > 1.1) {
      ratio = 1.1;
    }
    document.getElementsByTagName('html')[0].style.fontSize = ratio * 100 + 'px';
  }
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/Register" component={Register} />
          <Route path="/" component={Home} {...this.state} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
